import { IUserState, userActions } from "../../../state/user";
import { useDispatch, useSelector } from "react-redux";

import { IRootState } from "../../../state";

export const useUserStatusStore = () => {
  const dispatch = useDispatch();
  const { emailSignIn, phoneSignIn } = useSelector((state: IRootState) => state.user as IUserState);

  const setEmailSignIn = (email: string) => {
    dispatch(userActions.setEmailSignIn(email));
  };

  const setPhoneSignIn = (phone: string) => {
    dispatch(userActions.setPhoneSignIn(phone));
  };

  return {
    emailSignIn,
    setEmailSignIn,
    phoneSignIn,
    setPhoneSignIn,
  };
};

